/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Storage_Detailed_BreakdownInputs */



/**
* | output |
* | --- |
* | "Detailed Breakdown" |
*
* @param {Dashboard_Storage_Detailed_BreakdownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_detailed_breakdown = /** @type {((inputs?: Dashboard_Storage_Detailed_BreakdownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_Detailed_BreakdownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Detaillierte Aufschlüsselung")
	return /** @type {LocalizedString} */ ("Detailed Breakdown")
});